import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { useIsSmallViewport } from "hooks/useIsSmallViewport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { rewriteChartTooltipData } from "stores/genericStore/actions";
import {
  useGenericDispatch,
  useChartTooltipData,
} from "stores/genericStore/GenericContext";
import { useRouting } from "stores/routingStore/RoutingContext";
import classes from "./ChartMarkerClearButton.module.css";

/**
 * Clears the chart position marker on both the chart and the map.
 * On mobile the marker stays visible after tapping the chart (there is no hover),
 * so this is shown only on small viewports while the marker is displayed.
 */
export const ChartMarkerClearButton = () => {
  const { t } = useTranslation();
  const chartTooltipData = useChartTooltipData();
  const genericDispatch = useGenericDispatch();
  const isSmallViewport = useIsSmallViewport();
  const {
    state: { trackWaypoints },
  } = useRouting();

  // Same condition as ChartMarker, ChartTooltip and VerticalBar use on mobile
  const isMarkerShown =
    isSmallViewport && chartTooltipData && trackWaypoints.length > 1;

  if (!isMarkerShown) return null;

  return (
    <ActionIcon
      variant="light"
      aria-label={t("chart_options_menu.clear_marker")}
      onClick={() => genericDispatch(rewriteChartTooltipData(null))}
      className={classes.button}
    >
      <FontAwesomeIcon icon={faEraser} />
    </ActionIcon>
  );
};
